// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Y4qB","productName":"Table_productName__3p1d_"};